"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.for-each");

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _utils = require("../helpers/utils");

var _bind = _interopRequireDefault(require("../mixins/bind"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * DOM selectors.
 */


var selectors = {
  control: '[js-accordion="control"]',
  item: '[js-accordion="item"]',
  content: '[js-accordion="content"]'
};
/**
 * Export a new accordion instance.
 * @param {string} selector - The accordion item.
 * @param {object} config - Configuration.
 */

var _default = function _default(selector, config) {
  /**
   * Instance default settings.
   */
  var defaults = {
    aria: true,
    singleOpen: true,
    showInitial: false
  };
  /**
   * Instance settings.
   */

  var settings = (0, _utils.extendDefaults)(defaults, config);
  /**
   * DOM node selectors.
   */

  var nodeSelectors = {
    container: document.querySelector(selector),
    controls: _toConsumableArray(document.querySelector(selector).querySelectorAll(selectors.control)),
    items: _toConsumableArray(document.querySelector(selector).querySelectorAll(selectors.item))
  };
  /**
   * Initialise component bind.
   */

  var binder = (0, _bind["default"])(nodeSelectors.container);
  /**
   * Initialise component.
   */

  function init() {
    if (binder.isSet()) {
      return;
    }

    if (settings.aria) {
      setARIA();
    }

    if (settings.showInitial) {
      showInitialItem();
    }

    setClickEvents();
    binder.set();
  }
  /**
   * Set click events on items.
   */


  function setClickEvents() {
    nodeSelectors.controls.forEach(function (item, index) {
      (0, _utils.on)('click', item, function (event) {
        return onItemClick(event, item.parentNode, index);
      });
    });
  }
  /**
    * Handle toggle event on accordion control click.
    * @param {Event} event - Click event.
    * @param {HTMLElement} element - The accordion item.
    */


  function onItemClick(event, element, index) {
    event.preventDefault();
    toggleElement(element, index);
  }
  /**
   * Show targeted item and set ARIA values.
   * @param {HTMLElement} element - The accordion item.
   */


  function showItem(element) {
    element.classList.add(_cssClasses["default"].active);

    if (settings.aria) {
      updateARIA(element, true);
    }
  }
  /**
   * Hide targeted item and set ARIA values.
   * @param {HTMLElement} element - The accordion item.
   */


  function hideItem(element) {
    element.classList.remove(_cssClasses["default"].active);

    if (settings.aria) {
      updateARIA(element, false);
    }
  }
  /**
   * Check if item is active.
   * @param {HTMLElement} element - The accordion item.
   */


  function isItemActive(element) {
    return element.classList.contains(_cssClasses["default"].active);
  }
  /**
   * Hide all unselected items.
   * @param {HTMLElement} element - The accordion item.
   */


  function hideUnselected(element) {
    nodeSelectors.items.forEach(function (item) {
      if (isItemActive(item) && item !== element) {
        hideItem(item);
      }
    });
  }
  /**
   * Show initial item on init.
   */


  function showInitialItem() {
    nodeSelectors.items.forEach(function (element, index) {
      if (index === 0) {
        showItem(element);
        return;
      }

      hideItem(element);
    });
  }
  /**
   * Hide all items.
   */


  function hideAllItems() {
    nodeSelectors.items.forEach(function (item) {
      hideItem(item);
    });
  }
  /**
   * Toggle targeted item.
   * @param {HTMLElement} element - The accordion item.
   */


  function toggleElement(element, index) {
    Frame.EventBus.emit('Accordion:Toggle', index);

    if (settings.singleOpen) {
      hideUnselected(element);
    }

    if (isItemActive(element)) {
      hideItem(element);
      return;
    }

    showItem(element);
  }
  /**
   * Create ARIA attributes.
   */


  function setARIA() {
    nodeSelectors.container.setAttribute('role', 'tablist');
    nodeSelectors.container.setAttribute('aria-label', 'Accordion Control Group Buttons');
    nodeSelectors.items.forEach(function (item) {
      if (isItemActive(item)) {
        updateARIA(item, true);
        return;
      }

      updateARIA(item, false);
    });
  }
  /**
   * Update ARIA.
   * @param {HTMLElement} element - The accordion item.
   * @param {Boolean} value - Aria value.
   */


  function updateARIA(element, value) {
    element.setAttribute('aria-selected', value);
    element.querySelector(selectors.control).setAttribute('aria-expanded', value);
    element.querySelector(selectors.content).setAttribute('aria-hidden', !value);

    if (!itemHasContentId(element)) {
      updateARIAContentId(element);
    }
  }
  /**
   * Check if ARIA control contains content id.
   * @param {HTMLElement} element - The accordion item.
   */


  function itemHasContentId(element) {
    return element.querySelector(selectors.control).hasAttribute('aria-controls');
  }
  /**
   * Update ARIA content id.
   * @param {HTMLElement} element - Click The accordion item.
   */


  function updateARIAContentId(element) {
    var contentId = element.querySelector(selectors.content).id;
    element.querySelector(selectors.control).setAttribute('aria-controls', contentId);
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init,
    hideAllItems: hideAllItems,
    showInitialItem: showInitialItem
  });
};

exports["default"] = _default;